import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { SpectreAgentCardView } from '@/components/case-overview/SpectreAgentCardView'
import { useThreadList } from '@/features/agent/useAgentRuntime'

/**
 * Connected Xendrel AI hero for the case overview. Reads the chat thread
 * count and routes to the agent page (optionally pre-sending a prompt) when
 * the user submits the hero input.
 */
export function SpectreAgentCard({ caseId }: { caseId: string }) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { threads } = useThreadList(caseId, 'chat')
  const newConversationLink = `/cases/${caseId}/agent`

  return (
    <SpectreAgentCardView
      conversationCount={threads.length}
      suggestions={[
        t('caseOverview.assistant.lastMonth'),
        t('caseOverview.assistant.hypotheses'),
        t('caseOverview.assistant.watched'),
      ]}
      onStart={prompt =>
        navigate(
          prompt
            ? `${newConversationLink}?prompt=${encodeURIComponent(prompt)}`
            : newConversationLink
        )
      }
    />
  )
}
